import api from '@/services/api';
import { createComputed, createRoot } from 'solid-js';
import { createStore } from 'solid-js/store';
import { env } from './env';

function getLang() {
  return Object.values(env.langs).some((value) => value.includes(navigator.language)) ? navigator.language : 'en';
}

export const [setting, setSetting] = createRoot(() => {
  // 从 localStorage 获取初始值
  const storedSettings = JSON.parse(localStorage.getItem('setting') || '{}');
  let lastSavedSettings: Setting = { ...storedSettings };

  const [setting, setSetting] = createStore<Setting>(
    {
      lang: storedSettings.lang || getLang(),
      darken: storedSettings.darken !== undefined ? storedSettings.darken : true,
      theme: storedSettings.theme || 'follow-system',
      musicEnable: storedSettings.musicEnable !== undefined ? storedSettings.musicEnable : true,
      soundEnable: storedSettings.soundEnable !== undefined ? storedSettings.soundEnable : true,
    },
    { name: 'setting' }
  );

  // 只有第一次进入页面才会获取设置
  if (!Object.keys(storedSettings).length) {
    api.setting.get().then((res) => {
      setSetting({
        ...setting,
        lang: res.languageSetting,
        soundEnable: res.audioSetting,
        musicEnable: res.musicSetting,
      });

      lastSavedSettings = {
        lang: res.languageSetting,
        darken: setting.darken,
        theme: setting.theme,
        musicEnable: res.musicSetting,
        soundEnable: res.audioSetting,
      };
    });
  }

  // 监听设置的变化并存储到 localStorage
  createComputed(() => {
    localStorage.setItem('setting', JSON.stringify(setting));
    // 保存设置
    if (hasSettingsChanged(setting, lastSavedSettings)) {
      api.setting.save({
        languageSetting: setting.lang,
        musicSetting: setting.musicEnable,
        audioSetting: setting.soundEnable,
      });

      lastSavedSettings = { ...setting };
    }
  });

  createComputed(() => setSetting('darken', setting.theme !== 'light'));

  return [setting, setSetting] as const;
});

function hasSettingsChanged(currentSettings: Setting, lastSavedSettings: Setting): boolean {
  return (
    currentSettings.lang !== lastSavedSettings.lang ||
    currentSettings.darken !== lastSavedSettings.darken ||
    currentSettings.theme !== lastSavedSettings.theme ||
    currentSettings.musicEnable !== lastSavedSettings.musicEnable ||
    currentSettings.soundEnable !== lastSavedSettings.soundEnable
  );
}

interface Setting {
  lang: string;
  darken: boolean;
  theme: 'follow-system' | 'dark' | 'light';
  soundEnable: boolean;
  musicEnable: boolean;
}
